// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__r160V","title":"styles_title__BehRD"};